<div class="d-flex justify-content-right">
	<button *ngIf="showCustomFeeTooltip && !hideTooltip" class="cta-link-icon" (click)="isCustomFeeTooltipVisible = true">
		<ng-container>
			<icon type="arrow-right"></icon>
			<span dcrHTMLKey="CUSTOM_ADVISORY_FEE_TOOLTIP_CTA">Why Net Performance?</span>
		</ng-container>
	</button>
	<button class="cta-link-icon" (click)="openCustomAdvisoryFeeDialog()">
		<ng-container *ngIf="!customAdvisoryFee">
			<icon type="plus"></icon>
			<span dcrHTMLKey="ADD_CUSTOM_ADVISORY_FEE_TITLE">Add Custom Advisory Fee</span>
		</ng-container>
		<ng-container *ngIf="customAdvisoryFee && !showCurrentFee">
			<icon type="pencil"></icon>
			<span dcrHTMLKey="EDIT_CUSTOM_ADVISORY_FEE_TITLE">Edit Custom Advisory Fee</span>
		</ng-container>
		<ng-container *ngIf="customAdvisoryFee && showCurrentFee">
			<span class="current-fee-text padding-right-15 margin-right-15">
				<span class="text-12" dcrHTMLKey="CURRENT_CUSTOM_ADVISORY_FEE_SHORT_TITLE">Custom Advisory Fee:</span>
				<span class="text-bold">{{ customAdvisoryFee }}%</span>
			</span>
			<icon type="pencil"></icon>
			<span data-cy="edit-custom-advisory-fee-title" dcrHTMLKey="EDIT_CUSTOM_ADVISORY_FEE_SHORT_TITLE">Edit</span>
		</ng-container>
	</button>
</div>

<bfa-modal [(isVisible)]="isCustomFeeTooltipVisible" [enableClose]="true" [enableBackdrop]="true" width="680px">
	<div class="ac-modal">
		<div class="header">
			<h3 class="text-align-center" dcrHTMLKey="CUSTOM_ADVISORY_FEE_TOOLTIP_HEADER">Why net performance?</h3>
		</div>
		<div class="content larger d-flex text-align-center align-items-center">
			<span dcrHTMLKey="CUSTOM_ADVISORY_FEE_TOOLTIP_CONTENT"
				>Consistent with SEC guidance pertaining to the presentation of performance, the tools now display portfolio performance net of investment advisory fees.</span
			>
		</div>
	</div>
</bfa-modal>
